import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../lib/api';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash;
    const sessionId = new URLSearchParams(hash.replace('#', '')).get('session_id');
    const process = async () => {
      try {
        const { data } = await api.post('/auth/google/session', { session_id: sessionId });
        if (data?.token) localStorage.setItem('vq_token', data.token);
        await refresh();
        const role = data?.user?.role;
        navigate(['owner', 'admin'].includes(role) ? '/admin' : '/account', { replace: true, state: { user: data.user } });
      } catch {
        navigate('/login', { replace: true });
      }
    };
    process();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
      <p className="font-mono2 text-xs uppercase tracking-[0.25em] text-[#8A8F95]">Signing you in…</p>
    </div>
  );
}
